"use strict";
import Handlebars from "handlebars/dist/handlebars.js";
import { displayGenericError, serviceNetworkError } from "../failhandler";

var blockedBanners = (function () {

    var blockedTable = $('.t-blocked-banners');

    if (blockedTable.length > 0) {

        var main = $('#main'),
            source = $("#blocked-banners-template").html(),
            blockBtn = $('#block'),
            template = Handlebars.compile(source),
            responseWrap = blockBtn.closest('.module').find('.response-wrapper'),
            invalidMessage = responseWrap.attr('data-invalid-message'),
            noActiveBlocks = $('.no-active-blocks'),
            cl = new CanvasLoader('blocked-loader');

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#ffffff');
        cl.setFPS(24);

        main.on('click', '#block', function (e) {
            e.preventDefault();

            var value = $("#block-container select").val();

            if (value) {
                var bannerPageId = $("#block-container select").val(),
                    data = {
                        "bannerPageId": bannerPageId
                    };

                blockBtn.addClass('loading');
                cl.show();
                responseWrap.hide();

                var ajaxRequest = $.ajax({
                    url: SETTINGS.services.admin.methods.blockBanner,
                    data: JSON.stringify(data)
                });

                ajaxRequest.done(doneHandler);
                ajaxRequest.fail(failHandler);
            }
            else {
                responseWrap.text(invalidMessage).show();
            }
        });
    }

    function doneHandler(response) {

        if (response.Success) {
            var html = template(response.Data);

            if (blockedTable.hasClass('hidden')) {
                blockedTable.removeClass('hidden');
                noActiveBlocks.addClass('hidden');
            }

            
            blockedTable.find('tbody').html(html);

        } else {
            displayGenericError(responseWrap, response);
        }
        cl.hide();
        blockBtn.removeClass('loading');
    }

    function failHandler(jqXHR, textStatus, errorThrown) {
        cl.hide();
        serviceNetworkError(responseWrap);        
    }

})();